import React from 'react';
import LandingPageTemplate from '@/pages/LandingPageTemplate';
import { landingPageConfigs } from '@/pages/landingPageConfigs';

const LandingLBSW: React.FC = () => {
  return <LandingPageTemplate config={landingPageConfigs.lbsw} />;
};

export default LandingLBSW;
